<template>
  <SimpleModal
    :is-open="props.show"
    size="small"
    @close="emit('close')"
  >
    <div class="flex flex-col gap-6 px-7 py-10 pb-6">
      <div class="flex items-center gap-3 text-gray-900 text-xl leading-6 font-semibold">
        <FunnelIcon class="w-6 h-6" />
        <span>Save Filter</span>
      </div>
      <div class="flex flex-col gap-4">
        <p class="text-sm text-gray-600">Enter a name for this filter.</p>
        <input
          type="text"
          maxlength="40"
          v-model="filterName"
          @keyup.enter="onConfirm"
          class="w-full input-text"
        />
        <button
          class="btn btn-primary py-3 w-full md:w-auto"
          @click="onConfirm"
        >
          Save
        </button>
      </div>
    </div>
  </SimpleModal>
</template>

<script setup>
import { ref, watch } from 'vue'
import { FunnelIcon } from '@heroicons-2/vue/24/outline'
import SimpleModal from '@/Components/Modals/SimpleModal.vue'

const emit = defineEmits(['save'])

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  }
})

watch(
  () => props.show,
  (show) => {
    if (show) {
      filterName.value = null
    }
  }
)

const filterName = ref(null)

const onConfirm = () => {
  if (!filterName.value) {
    return
  }
  emit('save', { filterName: filterName.value })
  emit('close')
}
</script>
